import React, { useCallback } from 'react';

import { Checkbox } from '@vtblife/uikit';

import { Accreditation } from '@search/filter-enums/enums';

import { AccreditationFilter } from '../../../../models/Filter';
import { Filter2 } from '../../../new_filter/Filter2';
import { CheckboxGroup2 } from '../../../common/CheckboxGroup2';

const ITEMS = [
    [ Accreditation.ACCREDITED_BY_VTB, 'Аккредитовано ВТБ' ]
];

interface IProps {
    filter: AccreditationFilter;
    handleChange: (filter: AccreditationFilter) => void;
}

export const DesktopAccreditationFilterView: React.FC<IProps> = ({
    filter,
    handleChange
}) => {
    const onChange = useCallback(val => {
        if (val === null) {
            return;
        }

        if (Array.isArray(val)) {
            handleChange(new AccreditationFilter(val));
        }
    }, [ handleChange ]);

    return (
        <Filter2 filterTitle='Аккредитация'>
            <CheckboxGroup2
                mode='check'
                name='accreditation'
                onChange={onChange}
                value={filter.accreditation}
                colRestriction={2}
                isFilter
            >
                {
                    ITEMS.map(([ value, label ]) => (
                        <Checkbox
                            variant='filter'
                            key={value}
                            name={value}
                            block
                        >
                            {label}
                        </Checkbox>
                    ))
                }
            </CheckboxGroup2>
        </Filter2>
    );
};
